module.exports = __webpack_public_path__ + "media/images/banner/dmc/dmc-sp-ff51b3192b5431aaf2e86b15bce20c4d.png";